import Link from 'next/link';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { BRAND_ASSETS_LINK } from '@web/features/const';
import { Button } from '@web/ui/components';
import { SharpImage } from '@web/ui/components/SharpImage';
import { TileHyperLinkIcon } from '@web/ui/icons';
import { useDesignsTokenTheme } from '@web/ui/theme/ThemeProvider';

import { HubTile } from '../HubTile';

import BrandIllustrationDark from './brand-Illustration-dark.png';
import BrandIllustrationLight from './brand-Illustration-light.png';

const Container = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('2000')};
  padding-top: ${({ theme }) => theme.spacing('2000')};
`;

const VisualContainer = styled.div`
  display: flex;
  align-self: stretch;
  flex: 1 0 0;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  position: relative;
`;

const Visual = styled(SharpImage)`
  object-fit: contain;
  width: auto;
  min-width: 100%;
  height: 100%;
  min-height: 13.75rem;
  max-height: 15rem;
  max-width: 25rem;
`;

const SButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.green};
  width: 100%;
`;

export const BrandAssetsTile = () => {
  const { isDarkMode } = useDesignsTokenTheme();

  const t = useTranslations();
  return (
    <Link href={BRAND_ASSETS_LINK}>
      <HubTile
        textColor="onSurface"
        background="surfaceContainerLow"
        title={t('BRAND_ASSETS_HUB_TILE_TITLE')}
        badge={<TileHyperLinkIcon size="0750" />}
        stateLayer="onSurface"
      >
        <Container>
          <VisualContainer>
            <Visual
              src={isDarkMode ? BrandIllustrationDark : BrandIllustrationLight}
            />
          </VisualContainer>
          <Link href={BRAND_ASSETS_LINK}>
            <SButton label={t('BRAND_ASSETS_HUB_TILE_BUTTON')} />
          </Link>
        </Container>
      </HubTile>
    </Link>
  );
};
